<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Extemporáneos</v-toolbar-title>
      <select-input
        :form="form"
        :items="this.enrollments.map(v => { return { value: v.text, text: v.text }})"
        :label="$t('enrollments.extemporaneous.enrollment')"
        :v-errors="errors"
        name="enrollment_id_filter"
        v-model="search"
        class="ml-4"
      ></select-input>
      <v-spacer></v-spacer>
      <v-btn @click="uploadWizard = true; dataExcel = []; wizard = 0;">
        <span class="material-icons mr-2">library_add</span> Subir registros
      </v-btn>
      <v-btn color="primary" dark class="mb-2" @click="dialog = true">{{ $t('enrollments.extemporaneous.new') }}</v-btn>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="extemporaneous_enrollments"
      :rows-per-page-items="[10,20,50,{'text':$t('datatable.allRowsPerPageItems'),'value':-1}]"
      :rows-per-page-text="$t('datatable.rowsPerPageText')"
      :no-results-text="$t('datatable.noResultsText')"
      :no-data-text="$t('datatable.noDataText')"
      :search="search"
      :loading="loadingTable"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.enrollment }}</td>
        <td class="text-xs-center">{{ props.item.family_code }} {{ props.item.family }}</td>
        <td class="text-xs-center">{{ props.item.student && props.item.student.full_name }}</td>
        <td class="text-xs-center">{{ noveltyType.find(_ => _.value === props.item.type).text }}</td>
        <td class="text-xs-center">{{ props.item.system_access == 1 ? 'Si' : 'No' }}</td>
        <td class="text-xs-center">{{ props.item.start_date }}</td>
        <td class="text-xs-center">{{ props.item.finish_date }}</td>
        <td class="text-xs-center">{{ props.item.positive_balance }}</td>
        <td class="text-xs-center">{{ props.item.reason }}</td>
        <td>
          <v-tooltip top>
            <v-icon
              medium
              class="mr-2"
              @click="editExtemporaneous(props.item.id)"
              slot="activator"
            >
              edit
            </v-icon>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip top>
            <v-icon
              medium
              class="mr-2"
              @click="deleteItemDialog = true; deleteItem = props.item"
              slot="activator"
            >
              delete
            </v-icon>
            <span>Eliminar</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" max-width="500px">
        
        <v-card>
          <v-card-title>
            <span v-show="!editingExtemporaneous" class="headline">Nueva Novedad</span>
            <span v-show="editingExtemporaneous" class="headline">Editar Novedad</span>
          </v-card-title>

          <v-card-text>
            <v-container class="pa-0" grid-list-md>
              <select-input
                :form="form"
                :items="this.enrollments"
                :label="$t('enrollments.extemporaneous.enrollment')"
                :v-errors="errors"
                :value.sync="form.enrollment_id"
                name="enrollment_id"
                v-validate.disable="'required'"
                v-model="form.enrollment_id"
              ></select-input>

              <v-autocomplete
                v-model="currentFamilySearch"
                :items="familyResult"
                :loading="isLoading"
                :search-input.sync="searchFamily"
                color="primary"
                hide-no-data
                hide-selected
                :auto-select-first="editingExtemporaneous"
                item-text="name"
                item-value="name"
                :label="editingExtemporaneous ? `Editando familia: ${editingStringFamily}` : ''"
                :placeholder="editingExtemporaneous ? $t('enrollments.extemporaneous.new-family') : $t('enrollments.extemporaneous.family')"
                return-object
                clearable
                :error="inputSearchError"
              >
              </v-autocomplete>
              <has-error :form="form" field="family_id"></has-error>

              <select-input
                :form="form"
                :items="noveltyType"
                :label="$t('enrollments.extemporaneous.type')"
                :v-errors="errors"
                :value.sync="form.type"
                name="type"
                v-validate.disable="'required'"
                v-model="form.type"
              ></select-input>

              <select-input
                :form="form"
                :items="students"
                label="Estudiante"
                :v-errors="errors"
                :value.sync="form.student_id"
                name="student_id"
                v-validate.disable="'required'"
                v-model="form.student_id"
              ></select-input>

              <div v-if="form.type == 'PAYMENT'">
                <v-checkbox
                  color="primary"
                  name="payment_payroll"
                  class="mt-0"
                  v-model="form.payment_payroll"
                  :input-value="form.payment_payroll"
                  label="Descuento por nómina"
                ></v-checkbox>
                <div v-if="!form.payment_payroll">

                  <select-input
                    :form="form"
                    :items="[{value: 'PSE', text: 'PSE'}, {value: 'TC', text: 'TC'}]"
                    label="Método de Pago"
                    :v-errors="errors"
                    :value.sync="form.payment_method"
                    name="payment_method"
                    v-validate.disable="'required'"
                    v-model="form.payment_method"
                  ></select-input>

                  <v-text-field
                    :form="form"
                    label="Valor"
                    :v-errors="errors"
                    :value.sync="form.amount"
                    name="amount"
                    v-validate="'required'"
                    v-model="form.amount"
                    @keypress="onlyNumbers"
                  ></v-text-field>

                  <v-text-field
                    :form="form"
                    label="Referencia"
                    :v-errors="errors"
                    :value.sync="form.reference"
                    name="reference"
                    v-validate="'required'"
                    v-model="form.reference"
                  ></v-text-field>

                  <v-text-field
                    v-if="form.payment_method == 'TC'"
                    :form="form"
                    label="Últimos 4 dígitos de la TC"
                    :v-errors="errors"
                    :value.sync="form.tc_digits"
                    name="tc_digits"
                    v-validate="'required'"
                    v-model="form.tc_digits"
                    @keypress="onlyNumbers"
                  ></v-text-field>

                  <date-picker
                    :form="form"
                    label="Fecha de pago"
                    :v-errors="errors"
                    :value.sync="form.payment_date"
                    name="payment_date"
                    v-validate.disable="'required'"
                  ></date-picker>
                </div>
              </div>

              <div v-if="form.type == 'EXTEMP'">
                <select-input
                  :form="form"
                  :items="[{value: 1, text: 'Si'}, {value: 0, text: 'No'}]"
                  :label="$t('enrollments.extemporaneous.system_access')"
                  :v-errors="errors"
                  :value.sync="form.system_access"
                  name="system_access"
                  v-validate.disable="'required'"
                  v-model="form.system_access"
                ></select-input>

                <date-picker
                  v-if="form.system_access === 0"
                  :form="form"
                  :label="$t('enrollments.extemporaneous.start_date')"
                  :v-errors="errors"
                  :value.sync="form.start_date"
                  name="start_date"
                  v-validate.disable="'required'"
                ></date-picker>
                <has-error :form="form" field="start_date"></has-error>

                <date-picker
                  v-if="form.system_access === 0"
                  :form="form"
                  :label="$t('enrollments.extemporaneous.finish_date')"
                  :v-errors="errors"
                  :value.sync="form.finish_date"
                  name="finish_date"
                  v-validate.disable="'required'"
                ></date-picker>
              </div>

              <v-text-field
                v-if="form.type == 'POSITIVE_BALANCE' || form.type == 'FEE'"
                ref="positive_balance"
                :form="form"
                :label="form.type == 'POSITIVE_BALANCE' ? 'Saldo a favor' : 'Valor recargo'"
                :v-errors="errors"
                :value.sync="form.positive_balance"
                name="positive_balance"
                v-validate="'required'"
                v-model="form.positive_balance"
                @keypress="onlyNumbers"
            ></v-text-field>

              <text-area-input
                name="reason"
                :form="form"
                v-model="form.reason"
                :v-errors="errors"
                :value.sync="form.reason"
                v-validate.disable="'required'"
                :label="$t('enrollments.extemporaneous.reason')"
              ></text-area-input>


            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancelar</v-btn>
            <v-btn v-if="!editingExtemporaneous" color="blue darken-1" flat @click="saveExtemporaneous">Guardar</v-btn>
            <v-btn v-else color="blue darken-1" flat @click="updateExtemporaneous">Actualizar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
      v-model="deleteItemDialog"
      max-width="450"
      >
        <v-card v-if="Object.keys(deleteItem).length > 0">
          <v-card-title class="title red---text text--darken-2">Eliminar - ID # {{ deleteItem.id }}</v-card-title>
          <v-card-text>
            <table class="pa-2" width="100%">
              <tr><th class="text-xs-right pr-2">{{ $i18n.t('enrollments.extemporaneous.enrollment') }}</th><td>{{ deleteItem.enrollment }}</td></tr>
              <tr><th class="text-xs-right pr-2">{{ $i18n.t('enrollments.extemporaneous.family') }}</th><td>{{ deleteItem.family_code }} {{ deleteItem.family }}</td></tr>
              <tr><th class="text-xs-right pr-2">Estudiante</th><td>{{ deleteItem.student && deleteItem.student.full_name }}</td></tr>
              <tr><th class="text-xs-right pr-2">{{ $i18n.t('enrollments.extemporaneous.type') }}</th><td>{{ noveltyType.find(_ => _.value === deleteItem.type).text }}</td></tr>
              <tr><th class="text-xs-right pr-2">{{ $i18n.t('enrollments.extemporaneous.system_access') }}</th><td>{{ deleteItem.system_access == 1 ? 'Si' : 'No' }}</td></tr>
              <tr><th class="text-xs-right pr-2">{{ $i18n.t('enrollments.extemporaneous.start_date') }}</th><td>{{ deleteItem.start_date }}</td></tr>
              <tr><th class="text-xs-right pr-2">{{ $i18n.t('enrollments.extemporaneous.finish_date') }}</th><td>{{ deleteItem.finish_date }}</td></tr>
              <tr><th class="text-xs-right pr-2">Saldo positivo</th><td>{{ deleteItem.positive_balance }}</td></tr>
              <tr><th class="text-xs-right pr-2">{{ $i18n.t('enrollments.extemporaneous.reason') }}</th><td>{{ deleteItem.reason }}</td></tr>
            </table>
          </v-card-text>
          <v-card-actions>
            <v-btn color="red white--text" 
              @click="deleteExtemporaneous(deleteItem.id)">
              <span class="material-icons mr-2">delete</span> Eliminar registro
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="uploadWizard"
        max-width="1010"
      >
      <v-card> 
        <v-card-title class="title">
          Subir registros
        </v-card-title>
        <v-tabs v-model="wizard" align-left slider-color="accent" md12 lg12 xl12 class="elevation-2" >
          <v-tab key="step1">Paso 1</v-tab>
          <v-tab key="step2" :disabled="dataExcel.length == 0">Paso 2</v-tab>
          <v-tab-item key="step1">
            <v-card class="pa-2">
              <FileUpload
                id="upload"
                v-model="files"
                name="files[]"
                class="v-btn theme--dark primary"
                extensions="xlsx,xls"
                accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                :multiple="false"
                :size="1024 * 1024 * 10"
                @input-file="inputFile"
                ref="upload">
                <span class="material-icons mr-2 mt-1">upload_file</span> Subir XLSX
              </FileUpload>
              <a :href="`${appUrl}/utils/enrollment_extemporaneous_demo.xlsx`" target="_blank">Muestra .xlsx</a>
              <span v-if="dataExcel && dataExcel.length > 0" class="success--text">{{ dataExcel.length }} registros leídos</span>
            </v-card>
          </v-tab-item>
          <v-tab-item key="step2" class="pa-2">
            <v-data-table
              :headers="headers2.filter( x => x.value != 'id')"
              :items="dataExcel"
              :loading="isLoading"
              :items-per-page="10"
              :rows-per-page-text="$t('datatable.rowsPerPageText')"
              :no-results-text="$t('datatable.noResultsText')"
              :no-data-text="$t('datatable.noDataText')"
              :rows-per-page-items="[10,20,50,{'text':$t('datatable.allRowsPerPageItems'),'value':-1}]"
              class="table-striped mt-2"
              dense
              style="width: 100%"
            >
              <template slot="items" slot-scope="props">
                <tr :class="{'error': props.item.row_class }">
                  <td>{{ props.item.start_date }}</td>
                  <td>{{ props.item.finish_date }}</td>
                  <td>{{ props.item.family_id }}</td>
                  <td>{{ props.item.reason }}</td>
                  <td>{{ props.item.enrollment_id }}</td>
                  <td>{{ props.item.enrollment_status_id }}</td>
                  <td>{{ props.item.payment_id }}</td>
                  <td>{{ props.item.type }}</td>
                  <td>{{ props.item.system_access }}</td>
                  <td>{{ props.item.positive_balance }}</td>
                  <td>{{ props.item.student_id }}</td>
                  <td>{{ props.item.payment_payroll }}</td>
                  <td>{{ props.item.payment_method }}</td>
                  <td>{{ props.item.amount }}</td>
                  <td>{{ props.item.reference }}</td>
                  <td>{{ props.item.tc_digits }}</td>
                  <td>{{ props.item.payment_date }}</td>
                </tr>
              </template>
              <template v-slot:no-results>
                Su búsqueda para <b>"{{ search }}"</b> no obtuvo resultados.
              </template>
              <template v-slot:pageText="props">
                {{ props.pageStart }} - {{ props.pageStop }} {{ $t('datatable.pageTextOf') }} {{ props.itemsLength }}
              </template>
            </v-data-table>
            <v-btn color="success white--text" 
              v-if="dataExcel.length >0" 
              :disabled="fileErrors > 0"
              @click="process">
              <span class="material-icons mr-2">backup</span> Subir {{ dataExcel.length }} registros
            </v-btn>
            <span v-if="fileErrors" class="red--text text--darken-2">{{ fileErrors }} errores en el archivo, verifique</span>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Form from 'vform';
import axios from 'axios';
import XLSX from 'xlsx'
import FileUpload from 'vue-upload-component'

export default {
  name: 'enrollment-extemporaneous',
  components: {
    FileUpload
  },
  data() {
    return {
      appUrl: window.config.appUrl,
      userNameMaxLength: 60,
      entries: [],
      isLoading: false,
      currentFamilySearch: null,
      searchFamily: null,
      search: '',
      inputSearchError: false,
      dialog: false,
      headers: [
        { text: this.$i18n.t('enrollments.extemporaneous.enrollment'), align: 'center', value: 'enrollment', sortable: false },
        { text: this.$i18n.t('enrollments.extemporaneous.family'), align: 'center', value: 'family' },
        { text: 'Estudiante', align: 'center', value: 'family' },
        { text: this.$i18n.t('enrollments.extemporaneous.type'), align: 'center', value: 'type', sortable: false },
        { text: this.$i18n.t('enrollments.extemporaneous.system_access'), align: 'center', value: 'system_access', sortable: false },
        { text: this.$i18n.t('enrollments.extemporaneous.start_date'), align: 'center', value: 'start_date' },
        { text: this.$i18n.t('enrollments.extemporaneous.finish_date'), align: 'center', value: 'finish_date' },
        { text: 'Saldo positivo', align: 'center', value: 'positive_balance' },
        { text: this.$i18n.t('enrollments.extemporaneous.reason'), align: 'center', value: 'reason' },
        { text: 'Acciones', align: 'center', value: 'acciones' }
      ],
      headers2: [
        { text: this.$i18n.t('enrollments.extemporaneous.start_date'), align: 'center', value: 'start_date' },
        { text: this.$i18n.t('enrollments.extemporaneous.finish_date'), align: 'center', value: 'finish_date' },
        { text: this.$i18n.t('enrollments.extemporaneous.family'), align: 'center', value: 'family_id' },
        { text: this.$i18n.t('enrollments.extemporaneous.reason'), align: 'center', value: 'reason' },
        { text: this.$i18n.t('enrollments.extemporaneous.enrollment'), align: 'center', value: 'enrollment_id', sortable: false },
        { text: 'Enrollment Status ID', align: 'center', value: 'enrollment_status_id', sortable: false },
        { text: 'Payment ID', align: 'center', value: 'payment_id', sortable: false },
        { text: this.$i18n.t('enrollments.extemporaneous.type'), align: 'center', value: 'type', sortable: false },
        { text: this.$i18n.t('enrollments.extemporaneous.system_access'), align: 'center', value: 'system_access', sortable: false },
        { text: 'Saldo positivo', align: 'center', value: 'positive_balance' },
        { text: 'Estudiante', align: 'center', value: 'student_id' },
        { text: 'Nómina', align: 'center', value: 'payment_payroll' },
        { text: 'Método Pago', align: 'center', value: 'payment_method' },
        { text: 'Cantidad', align: 'center', value: 'amount' },
        { text: 'Referencia', align: 'center', value: 'reference' },
        { text: 'Dígitos', align: 'center', value: 'tc_digits' },
        { text: 'Fecha Pago', align: 'center', value: 'payment_date' }
      ],

      extemporaneous_enrollments: [],
      form: new Form({
        start_date: '',
        finish_date: '',
        family_id: '',
        reason: '',
        enrollment_id: '',
        system_access: 1,
        positive_balance: '',
        type: '',
        student_id: '',
        payment_payroll: false,
        payment_method: '',
        amount: '',
        reference: '',
        tc_digits: '',
        payment_date: '',
      }),
      enrollments: [],
      editingExtemporaneous: false,
      editingStringFamily: '',
      noveltyType: [
        {value: 'EXTEMP', text: 'Extemporáneo'},
        {value: 'PAYMENT', text: 'Pago'},
        {value: 'POSITIVE_BALANCE', text: 'Saldo a favor'},
        {value: 'FEE', text: 'Recargo'},
      ],
      students: [],

      wizard: null,
      dataExcel: [],
      files: [],
      uploadWizard: false,
      fileErrors: false,

      deleteItemDialog: false,
      deleteItem: {}
    }
  },

  computed: {
    familyResult() {
      return this.entries.map(user => {
        user.name.length > this.userNameMaxLength
          ? user.name.slice(0, this.userNameMaxLength) + '...'
          : user.name

        return Object.assign({}, user)
      })
    }
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
    searchFamily(val) {
      if (!val) {
        this.isLoading = false
        return
      }

      if (this.isLoading) return

      this.isLoading = true

      axios.get(`/api/family/search/${val}`)
        .then(res => {
          const { data } = res
          this.count = data.length;
          this.entries = data
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => (this.isLoading = false))
    },
    currentFamilySearch: function (newVal, oldVal) {
      if (newVal) {
        this.form.family_id = newVal.id;
        this.students = []
        axios.get(`/api/family/${newVal.id}/students`)
          .then(resp => {
            if (resp.status === 200) {
              this.students = resp.data.students
                .map(_ => ({value: _.id, text: _.full_name}))
            }
          })
          .catch(err => console.log(err))
        return;
      }
      this.form.family = '';
    }
  },

  created() {
    this.initialize()
  },

  methods: {
    async initialize() {
      this.loadingTable = true;
      this.getEnrollmentsList()
      const { data } = await axios.get('/api/enrollment/extemporaneous')
      this.extemporaneous_enrollments = data;
      this.loadingTable = false;
    },

    async getEnrollmentsList() {
      this.loadingTable = true;
      const { data } = await axios.get('/api/enrollments')
      data.forEach(enrollment => {
        this.enrollments.push({
          value: enrollment.id,
          text: enrollment.description
        })
      });
      this.isLoading = false;
    },

    ExcelToJSON ()  {
      this.parseExcel = (file)=> {
        let reader = new FileReader();

        reader.onload = (e)=> {
          let data = e.target.result;
          let workbook = XLSX.read(data, {
              type: 'binary'
          });
          workbook.SheetNames.forEach(function(sheetName) {
              // Here is your object
              let XL_row_object = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
              let json_object = JSON.stringify(XL_row_object);
              localStorage.setItem("dataExcelSchedule", JSON.stringify(XL_row_object));
          })
        };
        reader.onerror = function(ex) {
          console.log(ex);
        };

        reader.readAsBinaryString(file);
      };
    },
    handleFileSelect(file) {
      localStorage.removeItem("dataExcelSchedule");
      var xl2json = new this.ExcelToJSON();
      xl2json.parseExcel(file);
      setTimeout(() => {
        this.getUpLoadFile()
      }, 1500);
    },


    ExcelDateToJSDate(serialDate) {
      var days = Math.floor(serialDate);
      var hours = Math.floor((serialDate % 1) * 24);
      var minutes = Math.floor((((serialDate % 1) * 24) - hours) * 60)
      var new_date = new Date(Date.UTC(0, 0, serialDate, hours-5, minutes));
      return new_date.getDate()+'/'+(new_date.getMonth()+1) +'/'+new_date.getFullYear();
    },

    getUpLoadFile(){
      this.fileErrors = 0
      this.dataExcel = JSON.parse(localStorage.getItem("dataExcelSchedule")).map(obj=>{
          var row_class = "";
          if (!obj.family_id || obj.family_id == '' || !obj.reason || this.enrollments.filter(x => x.value == obj.enrollment_id).length === 0 || 
              this.noveltyType.filter(x => x.value == obj.type).length === 0 || obj.system_access === null || parseInt(obj.start_date) > parseInt(obj.finish_date)){
              row_class = "error"
              this.fileErrors += 1
          }

          return {
              row_class: row_class,
              start_date: parseInt(obj.start_date) > parseInt(obj.finish_date) ? 'ERROR-FECHAS' : obj.start_date ? this.ExcelDateToJSDate(obj.start_date) : '', 
              finish_date: obj.finish_date ? this.ExcelDateToJSDate(obj.finish_date) : '', 
              family_id: obj.family_id || 'FALTANTE', 
              reason: obj.reason || 'FALTANTE', 
              enrollment_id: this.enrollments.filter(x => x.value == obj.enrollment_id).length > 0 ? obj.enrollment_id : 'FALTANTE', 
              enrollment_status_id: obj.enrollment_status_id || '', 
              payment_id: obj.payment_id || '', 
              type: this.noveltyType.filter(x => x.value == obj.type).length > 0 ? obj.type : 'FALTANTE', 
              system_access: obj.system_access !== null ? obj.system_access : 'FALTANTE', 
              positive_balance: obj.positive_balance || '', 
              student_id: obj.student_id || '',
              payment_payroll: obj.payment_payroll || 0,
              payment_method: obj.payment_method || '',
              amount: obj.amount || '',
              reference: obj.reference || '',
              tc_digits: obj.tc_digits || '',
              payment_date: obj.payment_date ? this.ExcelDateToJSDate(obj.payment_date) : ''
          }
      });
    },
    inputFile(newFile, oldFile) {
      if (newFile && !oldFile) {
        this.handleFileSelect(newFile.file)
      }
      if (newFile && oldFile) {
        this.handleFileSelect(newFile.file)
      }
      if (!newFile && oldFile) {
        this.dataExcel = []
      }
    },

    close() {
      this.dialog = false
      this.editingExtemporaneous = false
      this.form = new Form({
        start_date: '',
        finish_date: '',
        family_id: '',
        reason: '',
        enrollment_id: '',
        system_access: 1,
        type: '',
        payment_payroll: false,
        payment_method: '',
        amount: '',
        reference: '',
        tc_digits: '',
        payment_date: '',
      })
    },

    async saveExtemporaneous() {
      if (this.form.start_date > this.form.finish_date) {
        this.form.errors.set({
          start_date: "La fecha inicial no puede ser mayor que la final"
        })
        return
      }

      if (this.form.family_id.trim() === '') {
        this.form.errors.set({
          family_id: "Debe seleccionar una familia"
        })
        return
      }

      const familyExists = this.extemporaneous_enrollments
        .filter(enrollment => enrollment.family_code == this.form.family_id &&
                              enrollment.enrollment_id == this.form.enrollment_id &&
                              enrollment.student_id == this.form.student_id)

      // EXTEMP
      // PAYMENT
      // system_access

      if (familyExists.length > 0) {

        let error = false
        let error_text = ''

        if (this.form.type === 'EXTEMP') {
          if (this.form.system_access === 1) {
            const family_extemp_ing = familyExists.filter(ex => ex.type === 'EXTEMP' && ex.system_access === 0).length
            const students = familyExists[0].students.length
            const family_extemp = familyExists.filter(ex => ex.type === 'EXTEMP' && ex.system_access === 1).length
            if (students === family_extemp) {
              error = true
              error_text = 'Máximo de extemporáneos para esta matrícula creados'
            }

            if (family_extemp_ing > 0) {
              error = true
              error_text = 'Familia con configuracion extemp. sin ingreso asignado'
            }
          } else {
            const family_extemp_ing = familyExists.filter(ex => ex.type === 'EXTEMP' && ex.system_access === 1).length
            const family_extemp = familyExists.filter(ex => ex.type === 'EXTEMP' && ex.system_access === 0).length
            if (family_extemp === 1) {
              error = true
              error_text = 'Esta familia ya existe para la matricula seleccionada'
            }
            if (family_extemp_ing > 0) {
              error = true
              error_text = 'Familia con configuracion extemp. con ingreso asignado'
            }
          }

        }
        if (this.form.type === 'PAYMENT') {
          const family_payment = familyExists.filter(ex => ex.type === 'PAYMENT').length
          const students = familyExists[0].students.length
          if (students === family_payment) {
            error = true
            error_text = 'Máximo de pagos para esta matrícula creados'
          }
        }

        if (this.form.type === 'POSITIVE_BALANCE') {
          const family_payment = familyExists.filter(ex => ex.type === 'POSITIVE_BALANCE').length
          const students = familyExists[0].students.length * 2
          if (students === family_payment) {
            error = true
            error_text = 'Máximo de saldos a favor para esta matrícula creados'
          }
          if (this.form.positive_balance == 0) {
            error = true
            error_text = 'El saldo a favor debe ser mayor a cero'
          }
        }

        if (this.form.type === 'FEE') {
          const family_payment = familyExists.filter(ex => ex.type === 'FEE').length
          const students = familyExists[0].students.length
          if (students === family_payment) {
            error = true
            error_text = 'Máximo de recargos para esta matrícula creados'
          }
          if (this.form.positive_balance == 0) {
            error = true
            error_text = 'El recargo debe ser mayor a cero'
          }
        }

        if (error) {
          this.form.errors.set({
            family_id: error_text
          })
          return
        }
      }

      if (await this.formHasErrors()) {
        console.log(JSON.stringify(this.formHasErrors()))
        console.log(JSON.stringify(this.form.errors))
      return
      }
      

      const result = await this.form.post('/api/enrollment/extemporaneous/create', this.form)

      if (result.status === 200) {
        this.initialize()
        this.currentFamilySearch = null
        this.form.clear();
        this.form.reset();
        this.$store.dispatch('responseMessage', {
          type: 'success',
          text: this.$t('enrollments.extemporaneous.stored-ok-text'),
          modal: false
        })
      }
      this.close()

    },

    process(){
      axios.post("/api/enrollment/extemporaneous/upload", { data: this.dataExcel })
          .then(resp=>{
            console.log(resp)
            if (resp.data.status === 200){
              this.$store.dispatch('responseMessage', { type: 'success', text:  `${this.dataExcel.length} registros subidos correctamente` })
              this.dataExcel = []
              this.uploadWizard = false
              this.initialize()
              this.currentFamilySearch = null
            } else {
              this.$store.dispatch('responseMessage', { type: 'error', text:  `Ocurrió un error, reintente nuevamente (${resp.data.data})` })
            }
          }).catch(error=>{
            this.$store.dispatch('responseMessage', { type: 'error', text:  `Ocurrió un error, reintente nuevamente (${error.response.data})` })
            console.log(error)
          })
    },

    editExtemporaneous(id_extemporaneous) {
      this.editingExtemporaneous = true;
      const extemporaneousToEdit = this.extemporaneous_enrollments.filter(enrollment_extemporaneuos => enrollment_extemporaneuos.id === id_extemporaneous)[0];
      const enrollmentSelected = this.enrollments.filter(enrollment => enrollment.text == extemporaneousToEdit.enrollment)[0]
      this.dialog = true;
      this.currentFamilySearch = {
        id: extemporaneousToEdit.family_code,
        name: extemporaneousToEdit.family
      }
      this.editingStringFamily = `${extemporaneousToEdit.family} ${extemporaneousToEdit.family_code}`
      this.form = new Form({
        start_date: extemporaneousToEdit.start_date,
        finish_date: extemporaneousToEdit.finish_date,
        family_id: this.currentFamilySearch.id,
        reason: extemporaneousToEdit.reason,
        enrollment_id: enrollmentSelected.value,
        id: extemporaneousToEdit.id,
        system_access: extemporaneousToEdit.system_access,
        type: extemporaneousToEdit.type,
        positive_balance: extemporaneousToEdit.positive_balance,
        student_id: extemporaneousToEdit.student_id,
        payment_payroll: extemporaneousToEdit.payment_payroll,
        payment_method: extemporaneousToEdit.payment_method,
        amount: extemporaneousToEdit.amount,
        reference: extemporaneousToEdit.reference,
        tc_digits: extemporaneousToEdit.tc_digits,
        payment_date: extemporaneousToEdit.payment_date,
      });
    },
    async updateExtemporaneous() {
      if (this.form.start_date > this.form.finish_date) {
        this.form.errors.set({
          start_date: "La fecha inicial no puede ser mayor que la final"
        })
        return
      }
      if (await this.formHasErrors()) return

      this.form.put('/api/enrollment/extemporaneous/update')
      .then(resp => {
        if (resp.status === 200) {
          this.initialize();
          this.dialog = false;
          this.editingExtemporaneous = false;
          this.form = new Form({
            start_date: '',
            finish_date: '',
            family_id: '',
            reason: '',
            enrollment_id: '',
            system_access: 1,
            type: '',
            positive_balance: '',
            student_id: '',
            payment_payroll: false,
            payment_method: '',
            amount: '',
            reference: '',
            tc_digits: '',
            payment_date: '',
          })
        }
      })
      .catch(error => console.log(error));
    },
    deleteExtemporaneous(id_extemporaneous) {
      axios.delete(`/api/enrollment/extemporaneous/${id_extemporaneous}/delete`)
        .then(resp => {
          if (resp.status === 200) {
            this.extemporaneous_enrollments = this.extemporaneous_enrollments
              .filter(enrollment_extemporaneuos => enrollment_extemporaneuos.id !== id_extemporaneous);
          }
        })
        .catch(error => console.log(error));
    },
    onlyNumbers($event) {
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if(keyCode == 45) { //This is a code por - (minus sign)
            $event.preventDefault();
        }
    },
  }
}
</script>

<style lang="scss">
.v-datatable.v-table tbody tr:nth-of-type(odd) {
  background-color: rgba(0,0,0,.03);
}
.v-datatable.v-table .width-200 {
  width: 200px !important;
}
tr.error td {
  background-color: #ffd1d1;
  color: #790000;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/enrollment/extemporaneous.vue